import { fromJS } from "immutable";
import * as types from "../constants";

const defaultState = fromJS({
  loading: false,
  storeInfomation: [],
  isSaverBar: false,
  responseSave: null,
  detailCurrentPackage: {},
  isVerifySenderEmail: true,
  isSendVerifyEmail: false,
  isShowModal: true,
});

const storeReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_STORE_INFOMATION:
      return state
        .setIn(["storeInfomation", action.payload.field], action.payload.value)
        .set("isSaverBar", true);

    case types.GET_STORE_INFOMATION_RESPONSE:
      if (!action.data) {
        return state;
      }
      return state.set("storeInfomation", action.data);

    case types.GET_CURRENT_PACKAGE_RESPONSE:
      if (!action.data) {
        return state;
      }
      return state
        .set("currentPackage", action.data)
        .set("detailCurrentPackage", fromJS(action.data));

    case types.SAVE_STORE_INFOMATION_RESPONSE:
      return state
        .set("responseSave", action.data.success)
        .set("isSaverBar", false);
    case "SHOW_MODAL_VERIFY_SENDER_EMAIL":
      return state.set("isVerifySenderEmail", action.data);
    case "SEND_EMAIL_VERIFY_SUCCESS":
      return state.set("isSendVerifyEmail", true);
    case "CLOSE_MODAL_VERIFY_EMAIL":
      return state.set("isShowModal", false);
    case "OPEN_MODAL_VERIFY_EMAIL":
      return state.set("isShowModal", true);
    default:
      return state;
  }
};
export default storeReducer;
